import { render, staticRenderFns } from "./aspect-dropdown-component.vue?vue&type=template&id=2ccae360&scoped=true&"
import script from "./aspect-dropdown-component.vue?vue&type=script&lang=ts&"
export * from "./aspect-dropdown-component.vue?vue&type=script&lang=ts&"
import style0 from "./aspect-dropdown-component.vue?vue&type=style&index=0&id=2ccae360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccae360",
  null
  
)

export default component.exports